module.exports = __webpack_public_path__ + "static/img/K.0f56e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/K.png
// module id = Vxx8
// module chunks = 0